import { useContext, useState } from 'react';
import { AuthContext } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import axios from '../../axios';
import '../stylesheets/LoginPage.css';

export function LoginPage() {
    const [user, setUser] = useState({login: '', password: ''});
    const [inputType, setInputType] = useState('password');
    const { login } = useContext(AuthContext);
    const navigate = useNavigate();

    const onChangeInput = (event) => {
        setUser({ ...user, [event.target.name]: event.target.value });
    }

    const handlerEye = (event) => {
        if (event.target.classList[1].includes('slash')) {
            event.target.classList.remove('fa-eye-slash');
            event.target.classList.add('fa-eye');
            setInputType('password');
        } else {
            event.target.classList.remove('fa-eye');
            event.target.classList.add('fa-eye-slash');
            setInputType('text');
        }
    }

    async function submitHandler(event) {
        event.preventDefault();

        try {
            const response = await axios.post('user/login', user);
            login(response.data.token, response.data.id, response.data.login);
            navigate('/admin');
            window.location.reload();
        } catch (error) {
            alert(error.response.data.message);
        }
    }

    return (
        <div className='LoginPage'>
            <h1>Admin page</h1>

            <form onSubmit={submitHandler}>
                <div className='form-item'>
                    <input
                        type='text'
                        name='login'
                        value={user.login}
                        placeholder='Login'
                        onChange={onChangeInput}
                    />
                </div>

                <div className='form-item'>
                    <input
                        name='password'
                        type={inputType}
                        value={user.password}
                        placeholder='Password'
                        onChange={onChangeInput}
                    />

                    <i className='fa-solid fa-eye' onClick={handlerEye} />
                </div>

                <input type='submit' value='Sign in' />
            </form>
        </div>
    )
}
